<style lang="scss" scoped>
main {
  form {
    width: 80%;
    margin: auto;
    margin-bottom: 3em;
  }
}
.loader {
  margin: 2em
}
</style>
<style lang="scss">
#roles {
  div {
    .d-flex {
      flex-wrap: wrap;
      .form-checkbox {
        width: 25%;
      }
    }
  }
}
</style>

<template>
  <main>
    <transition name="fade" mode="out-in">
      <div v-if="loaded && !success">
        <form @submit.prevent="submit()" class="columns">
          <dr-field
            prefix="form1"
            class="text-left"
            v-for="(field, name) in formData"
            v-bind:form.sync="formData"
            v-bind:field.sync="field"
            v-bind:validators.sync="$v.formData[name]"
            v-bind:apiErrors.sync="apiErrors[name]"
            :id="name"
            :ref="name"
            @clicked="focusedOffice = $event"
            :key="'main_'+name">
          </dr-field>
          <footer class="col-12 text-left">
            <button
              type="button"
              @click="$router.push('/doctor/users')"
              class="btn btn-green btn-sm"
            >
              Voltar
            </button>

            &emsp;

            <dr-submit
              :sending="sending"
              :disabled="$v.$invalid"
              :text="editUser ? 'Atualizar usuário' : 'Criar usuário'"
              class="btn-sm"
            />
          </footer>
        </form>
      </div>
      <dr-loader v-if="!loaded" size="lg" class="loader flex-center"></dr-loader>
    </transition>
  </main>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import { formData, validations } from '@/data/formData//usersOffice.js'
import { mapGetters } from 'vuex'

export default {
  props: ['users'],

  components: {
    drField,
    drSubmit
  },

  data () {
    return {
      formData: this.fn_COPY_OBJECT(formData),
      focusedOffice: null,
      rolesObj: null,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      officeRoles: {},
      loaded: false,
      success: false,
      sending: false
    }
  },

  validations: {
    formData: validations
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices',
      office: 'getCurrentOffice'
    }),

    editUser () {
      if (this.$route.params.id) {
        return this.$route.params.id
      }
      return false
    }
  },

  watch: {
    'formData.secretaryDoctorOffices.value': function (next, prev) {
      if (next.length === 0) {
        this.formData.roles.hide = true
        this.focusedOffice = null
      }
      if (next.length >= prev.length) {
        for (let office of next) {
          if (!this.officeRoles[office]) {
            this.officeRoles[office] = []
            this.focusedOffice = office
          }
        }
      } else if (next.length < prev.length) {
        let newObj = {}
        for (let office of next) {
          for (let officeRole in this.officeRoles) {
            if (parseInt(officeRole) === office) {
              newObj[parseInt(officeRole)] = this.officeRoles[parseInt(officeRole)]
            } else {
              if (parseInt(officeRole) === this.focusedOffice) {
                this.formData.roles.hide = true
                this.focusedOffice = null
              }
            }
          }
        }
        this.officeRoles = newObj
      }
    },

    focusedOffice (next, prev) {
      if (!next) {
        return
      }
      if (this.formData.secretaryDoctorOffices.value.indexOf(next) === -1) {
        this.officeRoles[next] = []
        this.formData.secretaryDoctorOffices.value.push(next)
        this.formData.roles.hide = false
      }
      for (let officeId in this.officeRoles) {
        if (next === parseInt(officeId)) {
          let officeName = null
          for (let office of this.doctorOffices) {
            if (parseInt(office.id) === next) {
              officeName = office.name
            }
          }
          this.formData.roles.label = this.rolesObj.label + ` – <strong>${officeName}</strong>`
          this.formData.roles.value = this.officeRoles[next]
          this.formData.roles.hide = false
        }
      }
    },

    'formData.roles.value': function (next) {
      if (this.focusedOffice) {
        if (this.officeRoles[this.focusedOffice]) {
          this.officeRoles[this.focusedOffice] = next
        }
      }
    }
  },

  mounted () {
    this.success = false
    // for (let field in this.formData) {
    //  this.formData.role.value = 'ROLE_SECRETARY'
    // }
    this.formData.secretaryDoctorOffices.value = []
    this.rolesObj = this.fn_COPY_OBJECT(formData.roles)
    this.formData.secretaryDoctorOffices.options = this.doctorOffices
    if (this.editUser) {
      this.fn_SHOW_PROGRESS()
      this.$http.get(`/doctor/doctor_office/${this.office.id}/user/${this.editUser}`, this.$store.getters.getAuthHeader).then(
        (res) => {
          // this.formData.secretaryDoctorOffices.value = this.doctorOffices[this.selectedOffice].id
          this.fn_FLATTEN_OBJECT({secretaryUser: res.data}).then(
            (data) => {
              console.log(data)
              for (let field in data) {
                if (this.formData[field]) {
                  this.formData[field].value = data[field]
                }
              }
              this.formData['secretaryUser.name'].disabled = true
              this.formData['secretaryUser.email.first'].disabled = true
              this.formData['secretaryUser.email.second'].hide = true
              this.formData['secretaryUser.email.first'].value = data['secretaryUser.email']
              this.formData['secretaryUser.email.second'].value = data['secretaryUser.email']
              for (let secretaryOffice of data['secretaryUser.secretary.secretaryDoctorOffices']) {
                for (let office of this.doctorOffices) {
                  if (office.id === secretaryOffice.doctor_office.id) {
                    this.formData['secretaryDoctorOffices'].value.push(office.id)
                    this.officeRoles[office.id] = secretaryOffice.roles
                    this.focusedOffice = office.id
                  }
                }
              }
              this.fn_HIDE_PROGRESS()
              this.loaded = true
            }
          )
        }
      )
    } else {
      this.loaded = true
    }
  },

  methods: {
    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      this.fn_SHOW_PROGRESS()
      let data = this.fn_COPY_OBJECT(this.formData)
      delete data['roles']
      // let officeId = data['secretaryDoctorOffices'].value
      data = this.fn_EXPAND_OBJECT(data)
      data['secretaryDoctorOffices'] = []
      for (let office in this.officeRoles) {
        data['secretaryDoctorOffices'].push(
          {
            roles: this.officeRoles[office],
            doctorOffice: office
          }
        )
      }
      let method = 'post'
      let endpoint = ''
      let msg = 'E-mail enviado com sucesso para o usuário'
      if (this.editUser) {
        delete data.secretaryUser
        method = 'put'
        endpoint = `/${this.editUser}`
        msg = 'Dados alterados com sucesso'
      }
      this.$http({
        url: `/doctor/doctor_office/0/user${endpoint}`, // checar eventualmente esta rota caso o id seja suprimido
        method,
        data: {'secretary': data},
        headers: this.$store.getters.getAuthHeader.headers
      }).then(
        (res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: msg,
            size: 'md',
            active: true
          })
          this.fn_HIDE_PROGRESS()
          this.$emit('update', true)
          this.$router.push({name: 'DoctorUsersOfficeList'})
          this.sending = false
        }
      ).catch(
        (err) => {
          if (typeof (err) === 'string') {
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: err,
              size: 'md',
              active: true
            })
            this.fn_HIDE_PROGRESS()
            this.sending = false
            this.formData['secretaryUser.email.first'].value = null
            this.formData['secretaryUser.email.second'].value = null
            return
          }
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            this.fn_HIDE_PROGRESS()
            this.sending = false
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        }
      )
    }
  }
}
</script>
